import React from 'react';

export const getFontFamily = (fontFamily: string): React.CSSProperties => {
  return fontFamily ? { fontFamily } : {};
};
